module.exports = __webpack_public_path__ + "ins04.png?73e2090d90b0f9236a0c1bb479649496";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins04.png
// module id = 155
// module chunks = 0